import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AddProduct = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);

  // 🚀 Upload Progress State
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);

  const [formData, setFormData] = useState({
    category_id: "",
    brand_id: "",
    name: "",
    slug: "",
    sku: "",
    short_description: "",
    description: "",
    price: "",
    compare_at_price: "",
    gst_percent: "18",
    stock: "",
    weight: "",
    status: "active",
  });

  const [primaryImage, setPrimaryImage] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);

  // 🚀 Dynamic Variants State Matrix
  const [variants, setVariants] = useState([]);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const res = await fetch(
          "https://rbuymart.rbhardwaj.com/server/api/products/brands.php"
        );
        const data = await res.json();
        if (Array.isArray(data)) setBrands(data);
        else if (data.brands) setBrands(data.brands);
      } catch (err) {
        console.error("Failed loading structural brands:", err);
      }
    };
    fetchBrands();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          "https://rbuymart.rbhardwaj.com/server/api/products/categories.php"
        );
        const data = await res.json();
        if (Array.isArray(data)) setCategories(data);
        else if (data.categories) setCategories(data.categories);
      } catch (err) {
        console.error("Failed loading structural categories:", err);
      }
    };
    fetchCategories();
  }, []);

  const handleNameChange = (e) => {
    const name = e.target.value;
    const slug = name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "");
    setFormData({ ...formData, name, slug });
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const addVariantField = () => {
    setVariants([...variants, { title: "", sku: "", price: "", stock: "" }]);
  };

  const removeVariantField = (index) => {
    const updatedVariants = variants.filter((_, i) => i !== index);
    setVariants(updatedVariants);
  };

  const handleVariantChange = (index, field, value) => {
    const updatedVariants = [...variants];
    updatedVariants[index][field] = value;
    setVariants(updatedVariants);
  };

 
  const handleSubmit = (e) => {
    e.preventDefault();

    const currentToken = localStorage.getItem("admin_token");
    if (!currentToken) {
      alert("Session missing. Please log in as an administrator again.");
      return;
    }

    setLoading(true);
    setUploadProgress(0);
    setShowProgressBar(true);

    const data = new FormData();
    Object.keys(formData).forEach((key) => data.append(key, formData[key]));

    if (primaryImage) data.append("primary_image", primaryImage);
    galleryImages.forEach((file) => data.append("gallery_images[]", file));

    if (variants.length > 0) {
      data.append("variants", JSON.stringify(variants));
    }

  
    const xhr = new XMLHttpRequest();

    // 1. Monitor upload progress
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = Math.round((event.loaded / event.total) * 100);
        setUploadProgress(percentComplete);
      }
    };

   
    xhr.onload = () => {
      setLoading(false);
      setShowProgressBar(false);
      
      let result;
      try {
        result = JSON.parse(xhr.responseText);
      } catch (err) {
        result = { message: "Failed to parse server response." };
      }

      if (xhr.status >= 200 && xhr.status < 300) {
        alert("Product along with architectural variants successfully cataloged!");
        navigate("/admin/products");
      } else {
        alert(`Error: ${result.message || "Something went wrong"}`);
      }
    };

   
    xhr.onerror = () => {
      setLoading(false);
      setShowProgressBar(false);
      alert("Network communication loop breakdown.");
    };

    xhr.open("POST", "https://rbuymart.rbhardwaj.com/server/api/admin/add_product.php");
    xhr.setRequestHeader("Authorization", `Bearer ${currentToken}`);
    xhr.send(data);
  };

  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "30px auto",
        padding: "25px",
        fontFamily: "sans-serif",
        background: "white",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      }}
    >
      <form onSubmit={handleSubmit} style={{ display: "grid", gap: "15px" }}>
        
      
        <div className="formlabeldiv">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleNameChange}
            required
          />
          <label>Product Display Name</label>
        </div>

      
        <div className="input-group">
          <div className="formlabeldiv">
            <select
              name="category_id"
              value={formData.category_id}
              onChange={handleInputChange}
              required
            >
              <option value="">-- Choose Valid Live Category --</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name} (ID: {cat.id})
                </option>
              ))}
            </select>
            <label>Category Selection</label>
          </div>

          <div className="formlabeldiv">
            <select
              name="brand_id"
              value={formData.brand_id}
              onChange={handleInputChange}
              required
            >
              <option value="">-- Choose Valid Live Brand --</option>
              {brands.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name} (ID: {b.id})
                </option>
              ))}
            </select>
            <label>Brand Selection</label>
          </div>

          <div className="formlabeldiv">
            <input
              type="text"
              name="slug"
              value={formData.slug}
              onChange={handleInputChange}
              required
            />
            <label>SEO Slug String</label>
          </div>
        </div>

      
        <div className="input-group">
          <div className="formlabeldiv">
            <input
              type="text"
              name="short_description"
              value={formData.short_description}
              onChange={handleInputChange}
            />
            <label>Short Teaser Description</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="text"
              name="sku"
              value={formData.sku}
              onChange={handleInputChange}
              required
            />
            <label>Unique SKU Identifier</label>
          </div>
        </div>

   
        <div className="formlabeldiv">
          <textarea
            name="description"
            rows="4"
            value={formData.description}
            onChange={handleInputChange}
          />
          <label>Full Broad HTML/Markdown Description</label>
        </div>

      
        <div className="input-group">
          <div className="formlabeldiv">
            <input
              type="number"
              name="stock"
              value={formData.stock}
              onChange={handleInputChange}
              required
            />
            <label>Available Units Stock</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="number"
              step="0.001"
              name="weight"
              value={formData.weight}
              onChange={handleInputChange}
            />
            <label>Weight (kg)</label>
          </div>
          <div className="formlabeldiv">
            <select
              name="status"
              value={formData.status}
              onChange={handleInputChange}
            >
              <option value="active">Active (Live in Shop)</option>
              <option value="inactive">Inactive (Archived Backstage)</option>
            </select>
            <label>Catalog Publishing Status</label>
          </div>
        </div>

      
        <div className="input-group">
          <div className="formlabeldiv">
            <input
              type="number"
              step="0.01"
              name="price"
              value={formData.price}
              onChange={handleInputChange}
              required
            />
            <label>Selling Price (₹)</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="number"
              step="0.01"
              name="compare_at_price"
              value={formData.compare_at_price}
              onChange={handleInputChange}
            />
            <label>Compare At Price/ MRP (₹)</label>
          </div>
          <div className="formlabeldiv">
            <select
              name="gst_percent"
              value={formData.gst_percent}
              onChange={handleInputChange}
            >
              <option value="0">0% (Exempt)</option>
              <option value="5">5% (FMCG)</option>
              <option value="12">12% (Electronics standard)</option>
              <option value="18">18% (Standard Services/Goods)</option>
              <option value="28">28% (Luxury items)</option>
            </select>
            <label>GST Taxation Rate (%)</label>
          </div>
        </div>

   
        <div
          style={{
            background: "white",
            padding: "15px",
            borderRadius: "6px",
            border: "1px solid #cbd5e1",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <label>
              Product Variants <br /> <small>(Optional: Size, Color configs)</small>
            </label>
            <button
              type="button"
              onClick={addVariantField}
              style={{
                padding: "6px 12px",
                background: "#3b82f6",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              + Add
            </button>
          </div>
          {variants.map((variant, index) => (
            <div className="input-group" key={index}>
              <div className="formlabeldiv">
                <input
                  type="text"
                  placeholder=""
                  value={variant.title}
                  onChange={(e) =>
                    handleVariantChange(index, "title", e.target.value)
                  }
                  required
               
                />
                <label>Title (e.g. Red / XL)</label>
              </div>

              <div className="formlabeldiv">
                <input
                  type="text"
                  placeholder=""
                  value={variant.sku}
                  onChange={(e) =>
                    handleVariantChange(index, "sku", e.target.value)
                  }
                  required
             
                />
                <label>Variant SKU</label>
              </div>
              <div className="formlabeldiv">
                <input
                  type="number"
                  step="0.01"
                  placeholder=""
                  value={variant.price}
                  onChange={(e) =>
                    handleVariantChange(index, "price", e.target.value)
                  }
                  required
                
                />
                <label>Price</label>
              </div>
              <div className="formlabeldiv">
                <input
                  type="number"
                  placeholder=""
                  value={variant.stock}
                  onChange={(e) =>
                    handleVariantChange(index, "stock", e.target.value)
                  }
                  required
          
                />
                <label>Stock</label>
              </div>
              <div className="formlabeldiv">
                <button
                  type="button"
                  onClick={() => removeVariantField(index)}
                  style={{
                    padding: "10px",
                    background: "#dc2626",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    width: "100%",
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>

      
        <div className="input-group">
          <div className="formlabeldiv">
            <label style={{ top: "-3px", zIndex: "3" }}>Thumbnail Image</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setPrimaryImage(e.target.files[0])}
              required
            />
          </div>

          <div className="formlabeldiv">
            <label style={{ top: "-3px", zIndex: "3" }}>Gallery Images</label>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={(e) => setGalleryImages(Array.from(e.target.files))}
            />
          </div>
        </div>

    
        {showProgressBar && (
          <div
            style={{
              background: "#f1f5f9",
              borderRadius: "6px",
              padding: "15px",
              marginTop: "10px",
              border: "1px solid #e2e8f0",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "6px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#475569",
              }}
            >
              <span>Uploading images and Data...</span>
              <span>{uploadProgress}%</span>
            </div>
            <div
              style={{
                width: "100%",
                height: "10px",
                background: "#cbd5e1",
                borderRadius: "5px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: `${uploadProgress}%`,
                  height: "100%",
                  background: "#2563eb",
                  transition: "width 0.2s ease-out",
                }}
              ></div>
            </div>
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            padding: "14px",
            background: loading ? "#94a3b8" : "#28a745",
            color: "#fff",
            fontSize: "16px",
            fontWeight: "bold",
            border: "none",
            borderRadius: "4px",
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading
            ? "Processing Relational Data Matrices..."
            : "Push Final Schema Entry to Storefront"}
        </button>
      </form>
    </div>
  );
};

export default AddProduct;